export default __webpack_public_path__ + "18ec377.png";